import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isHome && !scrolled
          ? 'bg-transparent'
          : 'bg-background-50/95 backdrop-blur-sm'
      }`}
    >
      <div className="px-4 md:px-6 py-3">
        <div className="flex items-center justify-between">
          <Link
            to="/"
            className={`font-heading text-lg font-semibold whitespace-nowrap ${
              isHome && !scrolled ? 'text-background-50' : 'text-foreground-900'
            }`}
          >
            乳交完全指南
          </Link>

          <div className="hidden md:flex items-center gap-6">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`text-sm whitespace-nowrap transition-colors duration-200 ${
                  isHome && !scrolled
                    ? 'text-background-50/80 hover:text-background-50'
                    : 'text-foreground-600 hover:text-foreground-900'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`text-sm whitespace-nowrap transition-colors duration-200 ${
                isHome && !scrolled
                  ? 'text-background-50/80 hover:text-background-50'
                  : 'text-foreground-600 hover:text-foreground-900'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            className={`md:hidden w-8 h-8 flex items-center justify-center cursor-pointer ${
              isHome && !scrolled ? 'text-background-50' : 'text-foreground-900'
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-3">
          <div className="flex flex-col gap-3">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="text-sm text-foreground-700 hover:text-foreground-900 py-1"
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="text-sm text-foreground-700 hover:text-foreground-900 py-1"
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}